import { FlairButtonVariants } from './index';

export const getClassName = (variant: FlairButtonVariants) => {
  switch (variant) {
    case 'primary':
      return 'flair-btn-primary';
  }
};
